<template>
  <!-- Begin page content -->
  <main class="flex-shrink-0">
    <div class="text-center mt-5 pt-5" v-if="busy">
      <div class="spinner-border text-warning" role="status"></div>
      <div>Solicitando</div>
      <div>{{ info }}</div>
    </div>
    <div class="container pt-4" v-else>
      <h6>
        Período: {{ yyyymm }} ({{ monthList[monthIndex] }}) | R$ {{ balance }}
      </h6>
      <div class="grid-panel grid-year mb-1">
        <div class="grid-body">
          <div
            class="btn grid-item"
            data-click-animation="pulse"
            @click.stop.prevent="year = year - 1"
          >
            <div>
              <i class="bi bi-chevron-double-left"></i>
            </div>
          </div>
          <div
            class="grid-item btn btn-default btn-info"
            data-content-animation="pulse"
          >
            <div class="bold">
              {{ year }}
            </div>
          </div>
          <div
            class="btn grid-item"
            data-click-animation="fadeIn"
            @click.stop.prevent="year = year + 1"
          >
            <div>
              <i class="bi bi-chevron-double-right"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-panel grid-month mb-4">
        <div class="grid-body">
          <div
            class="grid-item btn"
            data-click-animation="pulse"
            v-for="(item, ix) in monthList"
            :key="ix"
            :class="{ 'btn-primary': monthIndex == ix }"
            @click.stop.prevent="monthIndex = ix"
          >
            <div class="">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2 mx-2">
        <h6>Conta Corrente</h6>
        <div class="row">
          <div class="col text-center">
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                v-model="account_number"
              />
            </div>
          </div>
          <div class="col text-center">
            <div
              class="btn btn-secondary w-100"
              @click.stop.prevent="onOFX"
              :disabled="!isValid"
            >
              OFX
            </div>
          </div>
          <div class="col text-center">
            <a
              class="btn btn-primary w-100"
              :disabled="!isValid"
              :href="pdf"
              target="_blank"
            >
              PDF
            </a>
          </div>
        </div>
        <div class="row" v-if="download_list.length">
          <div class="col">
            <h6 class="mt-4 text-center">Extratos Salvos</h6>
            <div
              class="text-center mt-3"
              v-for="(i, ix) in download_list"
              :key="ix"
            >
              <a :href="i.url" target="_blank">Baixar Arquivo {{ i.id }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <!-- Begin page content -->
</template>

<script>
const base_api = "https://bank.usheet.me/api";
const animate = ($el, animation, prefix = "animate__") =>
  new Promise((resolve, reject) => {
    if (!$el || !$el.dataset || (!$el.dataset.animation && !animation)) return;
    const name = `${prefix}${animation || $el.dataset.animation}`;
    $el.classList.add(`${prefix}animated`, name, "animate__faster");
    $el.addEventListener(
      "animationend",
      (e) => {
        e.stopPropagation();
        $el.classList.remove(`${prefix}animated`, name, "animate__faster");
        resolve();
      },
      { once: true }
    );
  });

const addContentListener = ($el, handler) => {
  const closest = (node) => {
    if ((node.dataset || {})["contentAnimation"]) {
      return node;
    }
    return node.parentNode ? closest(node.parentNode) : null;
  };
  var observer = new MutationObserver((mutations) => {
    var found = false;
    mutations.forEach((mutation) => {
      if (!found && mutation.type == "characterData") {
        handler(closest(mutation.target));
      }
    });
  });
  observer.observe($el, {
    characterData: true,
    attributes: false,
    childList: false,
    subtree: true,
  });
};

const http_get = async (url, type) => {
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "GET",
    })
      .then((response) => {
        if (response.ok) {
          return !type || type == "json" ? response.json() : response.text();
        }
      })
      .then((data) => {
        if (data) {
          resolve(data);
        } else {
          reject(null);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  name: "AppContent",
  data() {
    return {
      busy: false,
      monthList: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ],
      monthIndex: new Date().getMonth(),
      year: new Date().getFullYear(),
      account_number: "",
      balance: "",
      download_url: "",
      download_list: [],
    };
  },
  computed: {
    yyyymm() {
      return `${this.year}-${String(this.monthIndex + 1).padStart(2, "0")}`;
    },
    info() {
      return `${this.account_number} - ${this.monthList[this.monthIndex]}/${
        this.year
      }`;
    },
    isValid() {
      return this.account_number && this.account_number.length >= 5;
    },
    pdf() {
      return (
        (this.account_number &&
          `${base_api}/pdf?a=${this.account_number}&m=${this.yyyymm}`) ||
        ""
      );
    },
    accessToken() {
      return this.$store.getters["gapi/accessToken"];
    },
    isReady() {
      return this.accessToken && this.account_number ? true : false;
    },
  },
  methods: {
    updateBalance() {
      if (!this.account_number) return;
      this.balance = "?";
      var url = `${base_api}/balance?a=${this.account_number}&m=${this.yyyymm}`;
      http_get(url)
        .then((r) => {
          this.balance =
            (r || {})["disponivel"] !== undefined ? r.disponivel : "";
        })
        .catch((e) => {
          this.balance = "erro";
        });
    },
    onStatement() {
      this.busy = true;
      if (!this.account_number) return;
      var url = `${base_api}/statement?a=${this.account_number}&m=${this.yyyymm}`;
      var url;
      http_get(url)
        .then((r) => {
          // this.$store.dispatch("gapi/uploadFile", {
          //   name: `Extrato Inter - ${this.info}`,
          //   content: JSON.stringify(r),
          //   mimetype: "application/json",
          // });
          this.busy = false;
        })
        .catch((e) => {
          this.busy = false;
          console.log(e);
        });
    },
    onOFX() {
      this.busy = true;
      if (!this.account_number) return;
      var url = `${base_api}/ofx?a=${this.account_number}&m=${this.yyyymm}`;
      var url;
      http_get(url, "text")
        .then((r) => {
          if (!r) return;
          this.upload(
            this.account_number,
            `Extrato Inter - ${this.info}.ofx`,
            "text/plain",
            r
          ).then((result) => {
            if (!result) return;
            this.download_list = this.download_list.filter(
              ({ id }) => id != this.info
            );
            this.download_list.push({
              id: this.info,
              url: result.url,
              ym: this.yyyymm,
            });
            this.download_list.sort((a, b) =>
              a.ym > b.ym ? 1 : a.ym < b.ym ? -1 : 0
            );
            window.localStorage.setItem(
              "bi",
              JSON.stringify({
                a: this.account_number,
                o: this.download_list,
              })
            );
            this.busy = false;
          });
        })
        .catch((e) => {
          this.busy = false;
          console.log(e);
        });
    },
    onClick($event) {
      animateCSS($event.target, "bounce");
    },
    async list() {
      try {
        let api = `https://script.google.com/macros/s/AKfycbyOv3PjotSrJszrbPcUsh17D4lOfUOe7xtnGt40un2F4Hz61CmT6iXMW51FIHYanuUP/exec?foldername=${this.account_number}`;
        const response = await fetch(api, {
          redirect: "follow",
          method: "GET",
        });
        response.json().then((r) => {
          if (!r || !r.length) return;
          let inserted = {};
          r.forEach((item) => {
            if (item.name in inserted) return;
            inserted[item.name] = true;
            this.download_list.push({
              id: item.name,
              url: item.url,
              ym: "",
            });
          });
        });
      } catch (e) {
        return null;
      }
    },
    async upload(foldername, filename, mimetype, content) {
      try {
        let api = `https://script.google.com/macros/s/AKfycbyOv3PjotSrJszrbPcUsh17D4lOfUOe7xtnGt40un2F4Hz61CmT6iXMW51FIHYanuUP/exec`;
        const response = await fetch(api, {
          redirect: "follow",
          method: "POST",
          body: JSON.stringify({
            foldername: foldername,
            filename: filename,
            mimetype: mimetype,
            data: btoa(content),
          }),
        });
        return await response.json();
      } catch (e) {
        return null;
      }
    },
    test() {
      var content =
        "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";
      this.upload(
        "41388100",
        "Extrato Inter - 41388100 - Mar/2024.ofx",
        "text/plan",
        content
      );
    },
  },
  watch: {
    info(n, o) {
      if (n && o && n != o) {
        this.updateBalance();
      }
    },
    isReady: {
      handler(n, o) {
        if (!o && n) {
          this.list();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    document
      .querySelectorAll("[data-click-animation]")
      .forEach((el) =>
        el.addEventListener("click", ($ev) =>
          animate(
            $ev.currentTarget,
            $ev.currentTarget.dataset["clickAnimation"]
          )
        )
      );
    document.querySelectorAll("[data-content-animation]").forEach((el) =>
      addContentListener(el, (target) => {
        target && animate(target, target.dataset["contentAnimation"]);
      })
    );
    var bi = window.localStorage.getItem("bi");
    if (bi) {
      bi = JSON.parse(bi);
      this.account_number = bi.a;
      // this.download_list = bi.o;
    }
  },
};
</script>

<style scoped>
.grid-panel {
  position: relative;
  display: inline-block;
  width: 80%;
  border-radius: 4px;
  margin-top: 20px;
  margin-left: 8%;
}

.grid-body {
  display: grid;
  position: absolute;
  gap: 5px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.grid-item {
  width: 100%;
  height: 100%;
  border: 1px solid gray;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-year {
  height: 40px;
}
.grid-year > .grid-body {
  grid-template-columns: 33.3333% 33.3333% 33.3333%;
  grid-template-rows: 100%;
}

.grid-month {
  height: 180px;
}

.grid-month > .grid-body {
  grid-template-columns: 33.3333% 33.3333% 33.3333%;
  grid-template-rows: 25% 25% 25% 25%;
}
</style>
